// extracted by mini-css-extract-plugin
export default {"aiTitleWrapper":"ai-title_aiTitleWrapper__LMllG","aiTitleText":"ai-title_aiTitleText__YTeNS","close":"ai-title_close__7w3Xl"};